<template>
  <div>
    <h3 class="blue-text">{{L10n('from-supplier-quote')}}</h3>
    <grid
      ref="grid"
      :config="gridConfig"
      class="no-grid-border"
      @handleCustomButtonGrid="handlerAddTo"
      @onGet="handlerGetData"
    />
  </div>
</template>

<script>
import gridConfig from './GridConfig'
import { ModelRFQ3ByRFQ2 } from '../../models'
import { waitValue } from '@/utils/promises'

export default {
  name: 'StocksGridIndex',
  components: {
    'grid': () => import(/* webpackChunkName: 'Grid' */ '@/components/Grid/Index')
  },
  props: {
    disabled: { type: Boolean, default: false },
    partID: { type: Number, required: true }
  },
  watch: {
    partID: {
      immediate: true,
      async handler () {
        const grid = await this.getGrid()
        if (!this.partID) {
          grid.resetData()
        } else {
          const rfq2ID = this.checkQuery()
          let filters = [`partID==${this.partID}`, rfq2ID && `id == ${rfq2ID}`].filter((v) => v)
          grid.setFilters(filters.join(' && '))
          grid.loadData()
        }
      }
    }
  },
  data () {
    return {
      rfq2ID: null
    }
  },
  computed: {
    gridConfig () {
      let rowControls = {
        left: {
          controls: [
            {
              type: 'custom',
              title: this.L10n('add-to-quote'),
              disabled: () => (this.disabled)
            }
          ]
        }
      }
      gridConfig['rowControls'] = rowControls
      return gridConfig
    }
  },
  methods: {
    async getGrid () {
      return waitValue(() => this.$refs['grid'])
    },
    handlerAddTo ({ row }) {
      let data = this.copyObjectProps(ModelRFQ3ByRFQ2(), { ...row })
      this.$emit('onAddQuote', data)
    },
    checkQuery () {
      let query = { ...this.$route.query }
      const key = 'quick-rfq-part-rfq2-id'
      const id = query[key] || null
      delete query[key]
      this.$router.replace({ ...this.$router.currentRoute, query })
      this.rfq2ID = id
      return id
    },
    handlerGetData (data) {
      if (this.rfq2ID) {
        const rowData = data.find(({ id }) => id === this.rfq2ID)
        this.handlerAddTo({ row: rowData })
      }
      this.rfq2ID = null
    }
  }
}
</script>
